import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'Workspace-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    progressBarValue: Number = 0;
    progressBarLabel: string = 'Loading...'

    constructor() {}

    ngOnInit() {
        window.addEventListener('beforeunload', function (event) {
            event.stopImmediatePropagation();
        }); 
    }

    onProgressBarChange(event){
        this.progressBarValue = event.progressBar;
        this.progressBarLabel = event.label;
      }
}
